import {Badge} from "@/components/ui/badge";
import {cn} from "@/lib/utils";

type VinIdentityBadgeProps = {
  className?: string;
};

export function VinIdentityBadge({className}: VinIdentityBadgeProps) {
  return (
    <Badge
      variant="info"
      className={cn("shrink-0 px-1.5 py-0 text-[10px] font-semibold uppercase tracking-wide", className)}
    >
      VIN
    </Badge>
  );
}
